export const COURSE_STATE = {
  ACT: 'ACTIVE',
  INACT: 'INACTIVE',
  PSD: 'PAUSED',
};

export const ELECTIVE_COURSE_ACTIONS = {
  ASSIGN_ELECTIVES: 'ASSIGN_ELECTIVES',
  UNASSIGN_ELECTIVES: 'UNASSIGN_ELECTIVES',
};

export const COURSE_TYPE = {
  CORE: 'CORE',
  ELECTIVES: 'ELECTIVES',
};

export const ACCESS_TYPE = {
  WITH_TEACHER: 'WITH_TEACHER',
};

export const ENROLLMENT_TYPE = {
  REGULAR: 'REGULAR',
};

export const STUDENT_COURSE_STATES = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PAUSED: 'PAUSED',
  READMIT: 'READMIT',
  HOLD: 'HOLD',
  SUSPENDED: 'SUSPENDED',
};
